import * as _ from 'lodash';
import { Component, Vue, Watch } from 'vue-property-decorator';

import Dialog from 'kpc/components/dialog';
import { Table, TableColumn } from 'kpc/components/table';
import Icon from 'kpc/components/icon';
import { Form, FormItem } from 'kpc/components/form';
import { Button, ButtonGroup } from 'kpc/components/button';
import Input from 'kpc/components/input';
import Spin from 'kpc/components/spin';
import { Tabs, Tab } from 'kpc/components/tabs';
import Tooltip from 'kpc/components/tooltip';
import Message from 'kpc/components/message';
import whiteList from "../../../service/common/whiteList";

import vpcData from "../../../service/vpc/vpcData";
import TableWithPagination from "../../../components/TableWithPagination/index.vue";
import getChargeTypeChina from '../../../service/common/getChargeTypeChina';
import apiRequest from '../../../service/vpc/request';

@Component({
    components: {
        Dialog,
        Table, TableColumn,
        Icon,
        Form, FormItem,
        Button, ButtonGroup,
        Input,
        TableWithPagination,
        Spin,
        Tabs, Tab,
        Tooltip
    }
})
export default class RepeatedRuleDialog extends Vue {
    cb?: () => void;
    region = '';
    type = '';
    rulesClone: any[] = [];
    checkedRepeatedRules: any[] = [];
    repeatedRulesWithDesc: any[] = [];
    repeatedRulesNoDesc: any[] = [];
    originArrParam: any[] = [];
    groupId = '';
    isOutRuleIP0: boolean = false;
    onOffNum = 0;
    vpcData: any = vpcData;
    getChargeTypeChina = getChargeTypeChina;
    allRepeatedRules: any[] = [];
    rulesNoDescArr: any[] = [];
    deletedRuleIdIn: any[] = [];
    noneRepeatedRuleIndex: any[] = [];
    repeatedRuleCheck: any = {
        show: false
    }

    get regionSupportDeny() {
        let me: any = this;
        return whiteList.check("sgSupportDeny", me.region);
    }

    get disabledOk() {
        let noRepeateRules = this.allRepeatedRules.length === 0;
        let hasRepeateDesc = false;
        if (this.rulesNoDescArr && this.rulesNoDescArr.length) {
            _.forEach(this.rulesNoDescArr, (item) => {
                if (item.length > 1) {
                    hasRepeateDesc = true;
                }
            });
        }
        
        return noRepeateRules && hasRepeateDesc;
    }

    onClose() {
        let me: any = this;
        me.isOutRuleIP0 = false;
        me.onOffNum = 0;
        me.allRepeatedRules = [];
        me.checkedRepeatedRules = [];
        me.rulesNoDescArr = [];
    }

    oneKeyDistinct() {
        const me: any = this;
        const keptRuleUuidArr: any[] = [];
        const allRepeatedRulesClone = _.cloneDeep(me.allRepeatedRules);
        // 将规则相同，备注相同的，需要保留的GroupEntryId记录下来
        if (me.repeatedRulesWithDesc.length > 0) {
            me.repeatedRulesWithDesc.forEach((arrItem: any) => {
                // 用户可能手工删除规则相同、备注相同的规则，在去重之前，判断用户手工删除剩余的规则之中的去重
                for (let i = 0; i < arrItem.length; i++) {
                    let leftRule: any = {};

                    if (me.originArrParam[arrItem[i]].Protocol === 'icmp') {
                        leftRule = _.find(me.allRepeatedRules, { Protocol: me.originArrParam[arrItem[i]].Protocol, CidrBlock: me.originArrParam[arrItem[i]].CidrBlock, IcmpType: me.originArrParam[arrItem[i]].IcmpType, IcmpCode: me.originArrParam[arrItem[i]].IcmpCode, Description: me.originArrParam[arrItem[i]].Description });
                    } else if (me.originArrParam[arrItem[i]].Protocol === 'ip') {
                        leftRule = _.find(me.allRepeatedRules, { Protocol: me.originArrParam[arrItem[i]].Protocol, CidrBlock: me.originArrParam[arrItem[i]].CidrBlock, Description: me.originArrParam[arrItem[i]].Description });
                    } else {
                        leftRule = _.find(me.allRepeatedRules, { Protocol: me.originArrParam[arrItem[i]].Protocol, CidrBlock: me.originArrParam[arrItem[i]].CidrBlock, PortRangeFrom: me.originArrParam[arrItem[i]].PortRangeFrom, PortRangeTo: me.originArrParam[arrItem[i]].PortRangeTo, Description: me.originArrParam[arrItem[i]].Description });
                    }

                    if (leftRule && leftRule.uuid) {
                        keptRuleUuidArr.push(leftRule.uuid);
                        break;
                    }
                }
            });
        }

        // 用上面记录的 UUID 来重新赋值去重之后的规则
        me.allRepeatedRules = me.allRepeatedRules.filter((rule: any) => {
            let existedFlag = false;
            keptRuleUuidArr.forEach(item => {
                if (item === rule.uuid) {
                    existedFlag = true;
                }
            });
            if (existedFlag) {
                return true;
            } else {
                // 获取被一键去重掉 SecurityGroupEntryId
                let canDelete = false;
                me.repeatedRulesWithDesc.forEach((itemArr: any) => {
                    itemArr.forEach((item: any) => {
                        if (me.originArrParam[item].SecurityGroupEntryId === rule.SecurityGroupEntryId) {
                            canDelete = true;
                        }
                    })
                })
                if (canDelete) {
                    me.deletedRuleIdIn.push(rule.SecurityGroupEntryId || "");
                }
            }
        });

        // 将规则相同，备注不同的规则放在 rulesNoDescArr 之中；
        me.repeatedRulesNoDesc.forEach((arrItem: any) => {
            const ruleGroup: any[] = [];
            // 为了区分在一组之内，既有规则相同、备注相同和规则相同、备注不同的规则，需要一个标志数组来记录，相同的规则是否已经放在了ruleGroup之中
            const exitedUuidArr: any[] = [];
            arrItem.forEach((item: any) => {
                // 之所以要遍历 allRepeatedRulesClone 是为了取得有 uuid 的repeatedRule
                for (let i = 0; i < allRepeatedRulesClone.length; i++) {
                    if (allRepeatedRulesClone[i].Protocol === 'icmp') {
                        if (allRepeatedRulesClone[i].Protocol === me.originArrParam[item].Protocol && allRepeatedRulesClone[i].CidrBlock === me.originArrParam[item].CidrBlock && allRepeatedRulesClone[i].IcmpType === me.originArrParam[item].IcmpType && allRepeatedRulesClone[i].IcmpCode === me.originArrParam[item].IcmpCode && allRepeatedRulesClone[i].Description === me.originArrParam[item].Description) {
                            let existedFlag = false;
                            exitedUuidArr.forEach((uuid: any) => {
                                if (uuid === allRepeatedRulesClone[i].uuid) {
                                    existedFlag = true;
                                }
                            })

                            if (!existedFlag) {
                                ruleGroup.push(allRepeatedRulesClone[i]);
                                exitedUuidArr.push(allRepeatedRulesClone[i].uuid);
                                break;
                            }
                        }
                    } else {
                        if (allRepeatedRulesClone[i].Protocol === me.originArrParam[item].Protocol && allRepeatedRulesClone[i].CidrBlock === me.originArrParam[item].CidrBlock && allRepeatedRulesClone[i].PortRangeFrom == me.originArrParam[item].PortRangeFrom && allRepeatedRulesClone[i].PortRangeTo == me.originArrParam[item].PortRangeTo && allRepeatedRulesClone[i].Description === me.originArrParam[item].Description) {
                            let existedFlag = false;
                            exitedUuidArr.forEach((uuid: any) => {
                                if (uuid === allRepeatedRulesClone[i].uuid) {
                                    existedFlag = true;
                                }
                            })

                            if (!existedFlag) {
                                ruleGroup.push(allRepeatedRulesClone[i]);
                                exitedUuidArr.push(allRepeatedRulesClone[i].uuid);
                                break;
                            }
                        }
                    }
                }
            });
            if (ruleGroup.length) {
                me.rulesNoDescArr.push(ruleGroup);
            }
        });
    }

    deleteSelectedRepeatedRules() {
        const me: any = this;
        if (me.allRepeatedRules.length == 1 || me.allRepeatedRules.length == me.checkedRepeatedRules.length) {
            Message.error(me.$trans(`至少保留一条规则!`));
            return;
        }
        if (me.checkedRepeatedRules.length > 0) {
            // 删除规则相同，备注相同的规则
            me.allRepeatedRules = me.allRepeatedRules.filter((repeatedRule: any) => {
                let isExisted = false;
                me.checkedRepeatedRules.forEach((checkedRule: any) => {
                    if (repeatedRule.uuid === checkedRule) {
                        isExisted = true;
                        if (repeatedRule.SecurityGroupEntryId) {
                            me.deletedRuleIdIn.push(repeatedRule.SecurityGroupEntryId);
                        }
                    }
                })
                if (!isExisted) {
                    return true;
                }
            });

            // 删除规则相同，备注不同的规则
            me.rulesNoDescArr = me.rulesNoDescArr.map((repeatedRulesNoDesc: any) => {
                return repeatedRulesNoDesc.filter((rule: any, index: any) => {
                    let isExisted = false;
                    me.checkedRepeatedRules.forEach((checkedRule: any) => {
                        if (rule.uuid === checkedRule) {
                            isExisted = true;
                            if (rule.SecurityGroupEntryId) {
                                me.deletedRuleIdIn.push(rule.SecurityGroupEntryId);
                            }
                        }
                    });
                    if (!isExisted) {
                        return true;
                    }
                })
            })
        }
        me.selectAllRules = [];
        me.checkedRepeatedRules = [];
    }

    deleteOneRule(row: any, index: any) {
        const me = this;
        if (me.allRepeatedRules.length == 1) {
            Message.error(me.$trans(`至少保留一条规则!`));
            return;
        }
        if (me.allRepeatedRules[index].SecurityGroupEntryId) {
            me.deletedRuleIdIn.push(me.allRepeatedRules[index].SecurityGroupEntryId);
        }
        me.allRepeatedRules.splice(index, 1);
    }

    deleteNoDescRule(delRule: any, event: any) {
        const me = this;
        if (me.allRepeatedRules.length == 1) {
            Message.error(me.$trans(`至少保留一条规则!`));
            return;
        }
        me.rulesNoDescArr = me.rulesNoDescArr.map(itemArr => {
            return itemArr.filter((item: any) => {
                if (item.uuid !== delRule.uuid) {
                    return true;
                } else {
                    if (delRule.SecurityGroupEntryId) {
                        me.deletedRuleIdIn.push(delRule.SecurityGroupEntryId);
                    }
                    return false;
                }
            });
        })

    }

    comparator(value: any, other: any) {
        if (value.CidrBlock === other.CidrBlock && value.Description === other.Description && value.PortRangeFrom === other.PortRangeFrom && value.PortRangeTo === other.PortRangeTo && value.Protocol === other.Protocol) {
            return true;
        }
    }
    comparatorNoDesc(value: any, other: any) {
        if (value.CidrBlock === other.CidrBlock && value.PortRangeFrom === other.PortRangeFrom && value.PortRangeTo === other.PortRangeTo && value.Protocol === other.Protocol) {
            return true;
        }
    }

    ok(val: any) {
        let me: any = this;
        let dialog: any = me.$refs.dialog;

        // 判断是否已经将重复的规则删除干净
        // 1. 判断规则相同，备注相同
        const originalRepeatCount = me.allRepeatedRules.length;
        const afterRepeatCount = _.uniqWith(me.allRepeatedRules, me.comparator).length;

        if (originalRepeatCount !== afterRepeatCount) {
            Message.error(me.$trans(`您还有相同备注的安全组规则未删除，请点击一键去重。`)); //您还有相同备注的安全组规则未删除，请点击一键去重。
            return;
        }

        // 2. 如果用户手工去重了规则、备注相同的规则，那么主动触发一键去重
        const originalRepeatNoDescCount = me.allRepeatedRules.length;
        const afterRepeatNoDescCount = _.uniqWith(me.allRepeatedRules, me.comparatorNoDesc).length;
        if (originalRepeatNoDescCount !== afterRepeatNoDescCount) {
            me.oneKeyDistinct();
            return;
        }

        // 3. 判断规则相同，备注不同
        let noDescRepeatFlag = false;
        me.rulesNoDescArr.forEach((itemArr: any) => {
            if (itemArr.length > 1) {
                noDescRepeatFlag = true;
            }
        })
        if (noDescRepeatFlag) {
            return;
        }

        // 先获取原来数组中所有非重复的规则
        me.rulesClone = me.rulesClone.filter((rule: any, ruleIndex: any) => {
            let equalFlag = false;
            me.noneRepeatedRuleIndex.forEach((noneRepeated: any) => {
                if (ruleIndex === noneRepeated) {
                    equalFlag = true;
                }
            })
            if (equalFlag) {
                return true;
            }
        })

        // 去重之后所有不重复的规则
        const allDistinctRules: any[] = [];
        // 1. 备注相同的
        me.allRepeatedRules.forEach((item: any) => {
            allDistinctRules.push(item);
        });

        // 2. 备注不同的
        me.rulesNoDescArr.forEach((itemArr: any) => {
            if (itemArr[0]) {
                allDistinctRules.push(itemArr[0]);
            }
        });

        allDistinctRules.forEach((rule: any) => {
            const obj: any = {
                Protocol: rule.Protocol,
                Direction: me.type == 'inRule' ? 'in' : 'out',
                CidrBlock: rule.CidrBlock ? rule.CidrBlock : '0.0.0.0/0',
                PortRangeFrom: rule.PortRangeFrom,
                PortRangeTo: rule.PortRangeTo,
                IcmpType: rule.IcmpType ? rule.IcmpType : '-1',
                IcmpCode: rule.IcmpIcmpCodeType ? rule.IcmpCode : '0',
                RuleName: '',
                RuleTag: rule.RuleTag,
                Description: rule.Description ? rule.Description : '',
                Range: '',
            }
            if (me.regionSupportDeny) {
                obj.Priority = rule.Priority;
                obj.Policy = rule.Policy;
            }
            if (rule.SecurityGroupEntryId) {
                obj.SecurityGroupEntryId = rule.SecurityGroupEntryId;
            }
            this.rulesClone.push(obj);
        })

        // 重置变量，如果用户一键去重之后还希望继续添加，则还能够操作
        me.repeatedRulesWithDesc = [];
        me.repeatedRulesNoDesc = [];
        me.allRepeatedRules = [];
        me.rulesNoDescArr = [];
        me.noneRepeatedRuleIndex = [];

        me.repeatedRuleCheck.show = false;
        dialog.hideLoading();
        me.cb && me.cb(this.rulesClone);
    }

    public open(region: string, type: string, allRepeatedRules: any[], rulesNoDescArr: any[], repeatedRulesWithDesc: any[], originArrParam: any[], repeatedRulesNoDesc: any[], cb: any) {
        let me: any = this;
        me.region = region;
        me.type = type;
        me.cb = cb;
        me.rulesClone = _.cloneDeep(allRepeatedRules);
        me.allRepeatedRules = allRepeatedRules;
        // me.rulesNoDescArr = rulesNoDescArr;
        me.repeatedRulesWithDesc = repeatedRulesWithDesc;
        me.originArrParam = originArrParam;
        me.repeatedRulesNoDesc = repeatedRulesNoDesc;
        me.repeatedRuleCheck.show = true;
        me.groupId = me.$route.params.groupId;
    }

    async created() {
    }
};

